import CryptoJS from "crypto-js"
import { CIPHER_KEY } from "../constants/keys.constants"

/** Decrypt data */
const decrypt = (information: any) => {
    /** check if information is a valid data type */
    try {
    
        if (typeof information === 'undefined' || information === null)
        return undefined
        
        let iv = CryptoJS.enc.Hex.parse("101112131415161718191a1b1c1d1e1f")
        const byteString = CryptoJS.AES.decrypt(information.toString(), CIPHER_KEY, {
            mode: CryptoJS.mode.CTR, iv: iv
        })

        const decryptedInfo = byteString.toString(CryptoJS.enc.Utf8)
        
        return decryptedInfo.length === 0 ? '' : JSON.parse(decryptedInfo)

    } catch (error) {
        return ''
    }
}

export default decrypt